import { Box, useMediaQuery, useTheme } from "@mui/material";
import type { FC } from "react";

type FooterProps = {
  inMainPage: boolean;
  inMagicShortcutFunc: boolean;
};

export const Footer: FC<FooterProps> = ({
  inMainPage,
  inMagicShortcutFunc,
}) => {
  // responsive UI
  const theme = useTheme();
  const notPhone = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box
      sx={{
        position: inMainPage || !notPhone ? "relative" : "absolute",
        bottom: "8px",
        display: "flex",
        flexDirection: notPhone ? "row" : "column",
        justifyContent: "space-between",
        gap: "8px",
        width: "100%",
        ":hover": {
          cursor: "pointer",
          textDecoration: "underline",
          color:
            inMainPage || inMagicShortcutFunc
              ? theme.palette.secondary.dark
              : theme.palette.primary.dark,
        },
        fontWeight: 600,
        fontSize: "13px",
      }}
    >
      <a
        href={`https://www.lingqi.tech/portal/home`}
        target="_blank"
        rel="noreferrer"
        style={{
          marginLeft: "16px",
        }}
      >
        &#169; {new Date().getFullYear()} 灵起科技
      </a>

      <Box
        sx={{
          display: "flex",
          justifyContent: notPhone ? "flex-end" : "space-between",
          gap: "8px",
          padding: "0 16px",
        }}
      >
        <a
          href={`https://beian.miit.gov.cn/#/Integrated/index`}
          target="_blank"
          rel="noreferrer"
        >
          京ICP备17061512号
        </a>
        <a
          href={`https://beian.mps.gov.cn/#/query/webSearch`}
          target="_blank"
          rel="noreferrer"
        >
          京公网安备11011502003341号
        </a>
      </Box>
    </Box>
  );
};
